const currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

export function money(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  const n = typeof value === "string" ? Number(value) : value;
  return Number.isFinite(n) ? currency.format(n) : "—";
}

export function plainNumber(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === "") return null;
  const n = typeof value === "string" ? Number(value) : value;
  return Number.isFinite(n) ? n : null;
}

const STATUS_LABEL: Record<string, string> = {
  draft: "Draft",
  in_stock: "In stock",
  listed: "Listed",
  sold: "Sold",
  shipped: "Shipped",
  donated: "Donated",
  lost: "Lost",
  damaged: "Damaged",
  queued: "Queued",
  active: "Live",
  delisted: "Delisted",
  ended: "Ended",
  error: "Needs attention",
};

export function statusLabel(status: string): string {
  return STATUS_LABEL[status] ?? status;
}

const AUDIENCE_LABEL: Record<string, string> = {
  adult: "Adult",
  kids: "Kids",
  baby: "Baby",
  unisex_all: "All ages",
};

export function audienceLabel(audience: string | null | undefined): string | null {
  if (!audience) return null;
  return AUDIENCE_LABEL[audience] ?? audience;
}

const CONDITION_LABEL: Record<string, string> = {
  nwt: "NWT",
  nwot: "NWOT",
  excellent: "Excellent",
  great: "Great",
  good: "Good",
  fair: "Fair",
};

export function conditionLabel(grade: string | null | undefined): string | null {
  if (!grade) return null;
  return CONDITION_LABEL[grade] ?? grade;
}

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export function monthNames(months: number[] | null): string {
  if (!months || months.length === 0) return "No clear season yet";
  return months.map((m) => MONTHS[m - 1]).join(", ");
}

export function shortDate(iso: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
